import axios from "axios";

class SumService1 {
  async getdata(values: {
    type: string;
    year: number;
    term: number;
    curriculum: number;
  }) {
    return await axios.post(`summary/getdata`, values);
  }

  async send(values: {
    year: number;
    term: number;
    type: string;
    sendBy: string;
    pathFile: string;
    curriculum: number;
    report: string;
  }) {
    return await axios.post(`summary`, values);
  }

  async onDelete(id: number) {
    return await axios.delete(`summary/${id}`);
  }
}
const SumService = new SumService1();
export default SumService;
